import { UserPreferences } from '@/app-modules/store/modules/user-preferences';
import { IPersistedStore } from '@/app-modules/store/persisted-store';
import { container } from '@/app-modules/_ioc';
import { SERVICE_IDENTIFIERS } from '@/app-modules/_ioc/service-identifiers';

export function getPathToCallImagesFolder(gameName: string, clubName: string, gameSkins: string[]): string {
    gameName = formatStringForFilePath(gameName);
    clubName = formatStringForFilePath(clubName);
    const persistedStore = container.get(SERVICE_IDENTIFIERS.IPersistedStore) as IPersistedStore;
    const userPreferences = persistedStore.Get(UserPreferences);
    const userCountry: string = userPreferences.country.toLowerCase();
    if (gameSkins.includes(clubName)) {
      return `/static/games/${gameName}/skins/${clubName}/calls/`;
    }
    else if (gameName === 'picturebingo' && userCountry === 'nl'){
      // very hacky but the way the game is defined for PB NL is different
      return `/static/games/${gameName}/skins/${gameSkins[0]}/calls/`;
    }
    return `/static/games/${gameName}/skins/default/calls/`;
}

function formatStringForFilePath(value: string): string {
    return value.replace(' ', '').toLowerCase();
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/_domain/helpers/skins.ts